import "react-pro-sidebar/dist/scss/styles.scss";
import { MenuStore } from "./Store";

export function MenuSide() {
  return <MenuStore />;
}
